__turbopack_context__.v({
  "bar": "AdminPendingBar-module__56knTW__bar",
  "fadeIn": "AdminPendingBar-module__56knTW__fadeIn",
  "label": "AdminPendingBar-module__56knTW__label",
  "progress": "AdminPendingBar-module__56knTW__progress",
  "progressFill": "AdminPendingBar-module__56knTW__progressFill",
  "slide": "AdminPendingBar-module__56knTW__slide",
});
